<template>
  <div>
    <b-link v-b-modal="modalId">
      {{ diploma.degree_name }}
    </b-link>
    <b-modal
      :id="modalId"
      :title="$t('Show diploma data')"
      hide-footer
      size="lg"
    >
      <table class="table">
        <tr
          v-for="field in fields"
          :key="field"
        >
          <th> {{ $t(`diploma.${field}`) }}</th>
          <td> {{ diploma[field] }}</td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import { VBModal, BLink } from 'bootstrap-vue'

export default {
  name: 'ShowDiplomModalComponent',
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BLink,
  },
  props: {
    diploma: {
      type: Object,
      required: true,
    },
    modalId: {
      type: String,
      default: () => 'show-diplom-data',
    },
    fields: {
      type: Array,
      default: () => [
        'degree_name',
        'edu_form_name',
        'institution_name',
        'diploma_serial',
        'diploma_number',
        'diploma_given_date',
        'speciality_name',
        'status_name',
        'edu_type_name',
      ],
    },
  },
}
</script>

<style scoped>

</style>
